import { getStore, removeStore, setStore } from "@/util/store";
import { foodmacMacruntimeWorkorderFindworkorderstatisticlist } from "@/api/hb-work-order/common";

const siteStore = {
    state: {
      // 当前操作的
      currentEditSiteObj:{},
      currentEditSiteMacObj:{},
      // 当前组网模式
      currentEditSiteNetworkMode:'',
      // 操作类型
      // 投机 撤机 组网  
      editSiteType:'',
      // 当前进度条
      currentStep:{
        currentStepType: '',  // 比如 'direct-job'
        currentStepKey: 10,   // 当前 process（10/20/30）
        currentStepStatus: '', // doing/success/fail
        stepDetail: {},       // 接口返回的原始数据（如errMsg/failed等）
      },
    },
    actions: {
    //    setCurrentEditAdsense({ commit }, data){
    //     // 存储当前type
    //     commit("SET_CURRENTEDITADSENSETYPE", data.type);
    //     // 存储当前id
    //     commit("SET_CURRENTEDITADSENSEID", data.id)
    //   }
    },
    mutations: {
      SET_CURRENT_EDIT_SITE_OBJ:(state, currentEditSiteObj) => {
        console.log(currentEditSiteObj,'---store里的当前店铺信息');
        state.currentEditSiteNetworkMode = currentEditSiteObj.siteNetworkMode
        state.currentEditSiteObj = currentEditSiteObj
      },
      // 编辑当前店铺下的机器
      SET_CURRENT_EDIT_SITE_MAC_OBJ:(state, obj) => {
        state.currentEditSiteMacObj = obj
      },
      SET_CURRENT_EDIT_NET_WORK_MODE:(state, val) => {
        state.currentEditSiteNetworkMode = val
      },
      // 当前的编辑类型
      SET_EDIT_SITE_TYPE:(state, editSiteType) => {
        console.log(editSiteType,'----当前');
        state.editSiteType = editSiteType
      },
      // 存储当前进度条
      SET_CURRENT_SITE_STEP:(state, currentStep) => {
        state.currentStep = currentStep
      },
    }
  }; 
  export default siteStore